import React, { useState, useContext } from 'react'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Card, CardContent, CardHeader, Avatar, Typography, Tab, Button, Box } from '@mui/material'

import Lottie from 'lottie-react'
import StarIcon from '@mui/icons-material/Star'
import RouterHook from '../../../../contexts/RouterHook'
import { Alerts, InputButton } from '../../../Simple'
import { ChatContext } from '../../../../contexts/ChatContext'
import { starAnimated } from '../../../../assets'
import { LocalStorage } from '../../../../services'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { isSuperAvaliado } from '../../../../utils'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { IoChevronBackOutline } from 'react-icons/io5'
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded'
import AvaliacoesCentroEsportivo from '../../../Modais/AvaliacoesCentroEsportivo/AvaliacoesCentroEsportivo'
import { AuthContext } from '../../../../contexts/AuthContext'

export default function Contact() {
  const { sttAuthCtx } = useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { sttChatCtx, actionsChatCtx } = React.useContext(ChatContext)
  const emp = sttPg.empresa
  const serverRouter = RouterHook()

  const [selectedTab, setSelectedTab] = React.useState('1')

  const [mostrarAvaliacoes, setMostrarAvaliacoes] = useState(false)

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  function switchMostrarAvaliacoes() {
    setMostrarAvaliacoes(!mostrarAvaliacoes)
    actionsCtxEmps.clearPaginationAvaliacoes()
  }

  function AbrirChatDireto() {
    if (!sttAuthCtx.isLogged) {
      return Alerts.question('Aviso', 'Para acessar o chat é necessário estar logado. Deseja fazer login agora?', () => {
        serverRouter('login')
      })
    }
    if (sttChatCtx.modeChat !== 'diretos') actionsChatCtx.handleModeChat('diretos')
    LocalStorage.set('chat-selected', { mode: 'diretos', id: emp.idempresa })
    serverRouter('chat', userUCtx.usuario.idusuario)
  }

  return (
    <>
      {mostrarAvaliacoes && <AvaliacoesCentroEsportivo onClose={switchMostrarAvaliacoes} open={mostrarAvaliacoes} />}
      <Card
        style={{
          margin: '0 auto',
          border: '1px solid #ccc',
          width: '100%',
          borderRadius: '10px',
        }}
      >
        <CardHeader
          avatar={<IoChevronBackOutline className='icon-back-pg' onClick={() => serverRouter('back')} />}
          title={
            <Box display='flex' alignItems='center'>
              <Avatar sx={{ width: 140, height: 100 }} alt={emp.nome} variant='rounded' src={emp.urlFoto + emp.foto} style={{ marginRight: 10 }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', position: 'relative' }}>
                  <Typography variant='h6'>{emp.nome}</Typography>
                  {isSuperAvaliado(emp) && (
                    <Lottie animationData={starAnimated} loop={false} style={{ width: '37px', height: '37px', zIndex: 1, marginLeft: '10px' }} />
                  )}
                </Box>
                {emp.mediaAvaliacoes > 0 && (
                  <InputButton
                    className='tw-justify-start contain-padding-zero tw-w-full'
                    variant='text'
                    sx={{ display: 'flex', justifyContent: 'flex-start', padding: '0px' }}
                    startIcon={<StarIcon sx={{ color: '#FFD700' }} />}
                    endIcon={<ArrowForwardIosIcon sx={{ width: '14px', height: '14px' }} />}
                    onClick={switchMostrarAvaliacoes}
                  >
                    <Typography variant='body2' sx={{ color: 'black' }}>
                      {`${emp.mediaAvaliacoes.toFixed(1)} (${emp.quantidadeAvaliacoes} avaliações)`}
                    </Typography>
                  </InputButton>
                )}
              </Box>
            </Box>
          }
          action={
            <Box>
              <Button
                size='large'
                variant='outlined'
                startIcon={<QuestionAnswerRoundedIcon />}
                style={{ marginBottom: 8, marginRight: '20px' }}
                onClick={() => {
                  AbrirChatDireto()
                }}
              >
                Conversar
              </Button>
            </Box>
          }
        />
        <CardContent sx={{ pt: 0, '&:last-child': { pb: 2 } }}>
          <TabContext value={selectedTab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange}>
                <Tab label='Descrição' value='1' />
                <Tab label='Informações Gerais' value='2' />
                <Tab label='Regra de Cancelamento' value='3' />
              </TabList>
            </Box>
            <TabPanel sx={sxTabPanel} value='1'>
              <Typography variant='body1'>{emp.descricao}</Typography>
            </TabPanel>
            <TabPanel sx={sxTabPanel} value='2'>
              <Typography variant='body1'>{emp.informacoesGerais}</Typography>
            </TabPanel>
            <TabPanel sx={sxTabPanel} value='3'>
              {emp.regrasCancelamento ? (
                actionsCtxEmps.ShowRegraCancelamento(emp.regrasCancelamento[0])
              ) : (
                <Typography variant='body1'>Não há regras de cancelamento cadastradas</Typography>
              )}
            </TabPanel>
          </TabContext>
        </CardContent>
      </Card>
    </>
  )
}

const sxTabPanel = {
  px: 2,
  pt: 2,
  pb: 0,
}
/*
  {
    "status": true,
    "retorno": {
        "idchat_empresa_usuario": 5824,
        "empresa_idempresa": 1405,
        "usuario_idusuario": 98342,
        "chat_idchat": 1169716,
        "status": "ABERTO",
        "abertoPor": "usuario",
        "createdAt": "2024-09-26T15:03:44.000Z",
        "updatedAt": "2024-09-26T15:03:44.000Z",
        "chat": {
            "idchat": 1169716,
            "status": "ABERTO",
            "createdAt": "2024-09-26T15:03:44.000Z",
            "updatedAt": "2024-09-26T15:03:44.000Z",
            "ultimaMensagem": null,
            "mensagens": [],
            "chat_empresa_usuario": {
                "idchat_empresa_usuario": 5824,
                "empresa_idempresa": 1405,
                "usuario_idusuario": 98342,
                "chat_idchat": 1169716,
                "status": "ABERTO",
                "abertoPor": "usuario",
                "createdAt": "2024-09-26T15:03:44.000Z",
                "updatedAt": "2024-09-26T15:03:44.000Z"
            }
        },
        "usuario": {
            "idusuario": 98342,
            "nome": "Suporte Agendei Quadras",
            "username": "williannike@gmail.com",
            "usuario": "williannike@gmail.com",
            "admin": 0,
            "exclusivo": 0,
            "adminGeral": 1,
            "estado": "Rio Grande do Sul",
            "cidade": "Alegrete",
            "perfilAfiliado": 0,
            "senhaResetToken": "13784",
            "senhaResetExpiracao": "2024-09-16T22:40:14.000Z",
            "dataPrimeiroAgendamento": "2023-03-06T18:18:49.000Z",
            "criadoPorAPI": false,
            "emailUsuarioNovaReserva": true,
            "emailUsuarioReservaAprovada": true,
            "emailUsuarioReservaCancelada": true,
            "emailGestorNovaReserva": true,
            "emailGestorReservaCancelada": true,
            "novoGestor": false,
            "createdAt": "2023-02-07T18:17:43.000Z",
            "updatedAt": "2024-09-26T13:48:11.000Z",
            "estadoAtuante": null,
            "criadoInternoPor": null,
            "bloqueadoAte": null,
            "motivoBloqueio": null,
            "professor": 0,
            "professorCriadoPor": null,
            "atleta_idatleta": 98382,
            "perfilAcesso_idperfilAcesso": 1097,
            "atleta": {
                "idatleta": 98382,
                "nome": "WillianClient",
                "ddi": "55",
                "telefone": "(53) 99979-1903",
                "nascimento": "1993-02-10",
                "email": "williannike@gmail.com",
                "sexo": "Masculino",
                "rua": null,
                "bairro": null,
                "numero": null,
                "cidade": null,
                "estado": null,
                "usuario_idusuario": 98342,
                "fromSite": false
            }
        },
        "empresa": {
            "idempresa": 1405,
            "nome": "Arena Esporte",
            "descricao": "Lugar de gente feliz e animada!",
            "status": 1,
            "foto": "foto-1726602387934-1405.jpeg",
            "informacoesGerais": "🥳",
            "cancelamentos": null,
            "agendamentos": null,
            "telefone": null,
            "facebook": null,
            "site": null,
            "urlFoto": "https:
            "createdAt": "2024-09-06T19:13:45.000Z",
            "updatedAt": "2024-09-26T13:18:21.000Z",
            "views": 68,
            "criadoPor": null,
            "gmt": -3,
            "licenca_idlicenca": 1518,
            "statusCredenciamento": "ATIVO",
            "statusVerificacaoConta": "VERIFICADA",
            "recebimentos_online": false,
            "recebimentos_dinheiro": true,
            "recebimentos_pix": false,
            "recebimentos_maquina_local": false,
            "aceitaCupom": true,
            "mediaAvaliacoes": 0,
            "quantidadeAvaliacoes": 0,
            "somaAvaliacoes": 0,
            "configurado": true,
            "empresaTeste": false,
            "cardTrello": null,
            "urlTrello": null,
            "username": "rs-alegrete-arena-esporte",
            "dataConfiguracaoMarketplace": "2024-09-12T19:36:09.000Z",
            "visibilidade": "PUBLICO",
            "descricaoVisibilidade": null,
            "aceitaDiarias": false,
            "aceitaAulas": false,
            "baixaAutomatica": true,
            "solicitaCPF": false,
            "cidade_idcidade": 1
        }
    }
  }
*/
